// extracted by mini-css-extract-plugin
export default {"logo_container":"NavbarDesktop_logo_container__klUx6","nav_desktop":"NavbarDesktop_nav_desktop__DBr5a","nav_container":"NavbarDesktop_nav_container__mPSWh"};